import { Component, OnInit, Input } from '@angular/core';
import { SearchResult } from '../../models/search.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { environment } from '../../../environments/environment';
import { NotifierService } from 'angular-notifier';


@Component({
  selector: 'app-searchresults',
  templateUrl: './searchresults.component.html',
  styleUrls: ['./searchresults.component.css']
})
export class SearchresultsComponent implements OnInit {
  
 filelocationapi: string =environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName=";
  constructor(private reportDashboardService:ReportdashboardService,  private notifier: NotifierService,) { }
 
  
  @Input() 
  searchResults:SearchResult[];
  
  firstPage:number;
  //totalrecs:number=this.searchResults.length;
  ngOnInit() { 
   
  }

  
 
  OpenFile(reportName:any)
  {
   // var windowfeatures = "status=yes";
    window.open(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName, '_blank');
    //window.open(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName, '_blank',windowfeatures);
    //window.open(environment.apiEndpoint+"/ReportSchedule/DownloadPublishedReportPDF?reportId="+reportId, '_blank');
      //  this.reportDashboardService.downloadPDF$(reportId).subscribe((content:Blob)=>{

      //  // window.open(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName, '_blank');
      //   const fileURL = window.URL.createObjectURL(content);
      //   setTimeout(() => window.open(fileURL, '_blank'), 1000);
      // //   // var a = document.createElement("a");
      // //   // document.body.appendChild(a);
      // //   // //a.style = "display: none";
        
      // //   //      //var json = JSON.stringify(content);
      // //   //      //blob = new Blob([json], {type: "octet/stream"});
      // //   //      let url = window.URL.createObjectURL(content);
      // //   //     a.href = url;
      // //   //     a.download = reportName+".pdf";
      // //   //     a.target ="_blank";
      // //   //     a.click();
      // //   //     window.URL.revokeObjectURL(url);
        
        
      //  },error=>{
      //    this.notifier.notify('error', 'File not found ,please contact administrator');
      //  });
  }
  paginate(event) {
    this.firstPage = event.first;
}

resetPageIndex()
{
  this.firstPage=0;
}
  LaunchReport(Id:any)
  {
     //console.log(Id);
    
      this.reportDashboardService.launchReport(Id).subscribe(
        (data) => {
 

           // console.log(data);
            var accessLink = environment.serverUrl+"/"+ data; // "ms-word:ofe|u|"+ environment.serverUrl+"/"+ data;
            const link = document.createElement('a');
            link.href = accessLink;
            link.setAttribute('visibility', 'hidden');
            link.click();
            //TODO: The above code is not working for IE but works for Chorme
            //window.open(this.accessLink);
    
          
        }
        
      );
      //this.voluntaryMetadataForm.disable();
      //console.log(this.accessLink);
    
  }

}



// WEBPACK FOOTER //
// ./src/app/search/searchresults/searchresults.component.ts